import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ModalProvider } from './components/AppModal';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Tickets from './pages/Tickets';
import TicketsKanban from './pages/TicketsKanban';
import TicketsAvisos from './pages/TicketsAvisos';
import TicketForm from './pages/TicketForm';
import TicketDetail from './pages/TicketDetail';
import Invoices from './pages/Invoices';
import InvoiceForm from './pages/InvoiceForm';
import Budgets from './pages/Budgets';
import Contracts from './pages/Contracts';
import ReceivedInvoices from './pages/ReceivedInvoices';
import QuarterReview from './pages/QuarterReview';
import Admin from './pages/Admin';
import Trash from './pages/Trash';
import Products from './pages/Products';
import Activities from './pages/Activities';
import Phonebook from './pages/Phonebook';
import Providers from './pages/Providers';
import CallCases from './pages/CallCases';
import Minerva from './pages/Minerva';
import Conversations from './pages/Conversations';
import OutboundCalls from './pages/OutboundCalls';
import Reminders from './pages/Reminders';
import Calendar from './pages/Calendar';
import Settings from './pages/Settings';
import DeclaracionResponsable from './pages/DeclaracionResponsable';

const PrivateRoute = ({ children }) => {
  const { token, loading } = useAuth();
  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Cargando...</div>;
  return token ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { token, loading } = useAuth();
  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Cargando...</div>;
  return !token ? children : <Navigate to="/" />;
};

function App() {
  return (
    <AuthProvider>
      <ModalProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
          <Route path="/register" element={<Navigate to="/login" />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="customers" element={<Customers />} />
            <Route path="tickets" element={<Tickets />} />
            <Route path="tickets/new" element={<TicketForm />} />
            <Route path="tickets/kanban" element={<TicketsKanban />} />
            <Route path="tickets/avisos" element={<TicketsAvisos />} />
            <Route path="tickets/:id" element={<TicketDetail />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="proformas" element={<Invoices proformaMode />} />
            <Route path="invoices/new" element={<InvoiceForm />} />
            <Route path="invoices/edit/:id" element={<InvoiceForm />} />
            <Route path="budgets" element={<Budgets />} />
            <Route path="contracts" element={<Contracts />} />
            <Route path="received-invoices" element={<ReceivedInvoices />} />
            <Route path="received-invoices/quarter-review" element={<QuarterReview />} />
            <Route path="products" element={<Products />} />
            <Route path="activities" element={<Activities />} />
            <Route path="phonebook" element={<Phonebook />} />
            <Route path="providers" element={<Providers />} />
            <Route path="call-cases" element={<CallCases />} />
            <Route path="conversations" element={<Conversations />} />
            <Route path="recordings" element={<Navigate to="/conversations" replace />} />
            <Route path="outbound-calls" element={<OutboundCalls />} />
            <Route path="reminders" element={<Reminders />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="settings" element={<Settings />} />
            <Route path="declaracion-responsable" element={<DeclaracionResponsable />} />
            <Route path="minerva" element={<Minerva />} />
            <Route path="admin" element={<Admin />} />
            <Route path="papelera" element={<Trash />} />
          </Route>
        </Routes>
      </Router>
      </ModalProvider>
    </AuthProvider>
  );
}

export default App;
